<template>
  <div>
    <div class="form-group row">
      <div class="col-md-6">
        <el-input type="search" name="search" placeholder="Search Comments" clearable v-model="searchQuery" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-table class="wrap-whole-words"
                  :data="queriedData"
                  border
                  style="width: 100%; margin-top: 10px; margin-bottom: 20px">
          <el-table-column
            :min-width="100"
            sortable
            :sort-method="(a, b) => callStringSort(a, b, 'inspectionType')"
            label="Inspection Type">
            <template v-slot="props">
              {{ props.row.inspectionType }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="100"
            sortable
            :sort-method="(a, b) => callStringSort(a, b, 'category')"
            label="Category">
            <template v-slot="props">
              {{ props.row.category }}
            </template>
          </el-table-column>
          <el-table-column
            :min-width="240"
            label="Comment">
            <template v-slot="props">
              {{ props.row.comment }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {stringSort} from '@/utilities/utils'
import _ from 'lodash'
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters({
      digitalForm: 'inspectorApp/digitalForm/edit',
    }),
    queriedData() {
      if (!this.searchQuery) {
        return this.comments
      }
      return this.comments
        .filter((row) => {
          let isIncluded = false
          if (row.comment) {
            const rowValue = row.comment.toLowerCase()
            if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
              isIncluded = true
            }
          }
          return isIncluded
        })
    }
  },
  data() {
    return {
      searchQuery: '',
      comments: []
    }
  },
  methods: {
    callStringSort(a, b, prop) {
      return stringSort(a, b, prop)
    },
    async compileComments() {
      if (!this.$store.get('inspectorApp/digitalForm/edit@id')) {
        await this.$store.dispatch('inspectorApp/digitalForm/fetchDigitalForm')
      }

      const digitalForm = this.$store.get('inspectorApp/digitalForm/edit')

      this.comments = []
      _.get(digitalForm, 'inspectionTypes', []).forEach(inspectionType => {
        const inspectionTypeName = inspectionType.name

        _.get(inspectionType, 'categories', []).forEach(category => {
          const categoryName = category.name

          _.get(category, 'comments', []).forEach(comment => {
            this.comments.push({
              inspectionType: inspectionTypeName,
              category: categoryName,
              comment: comment.value
            })
          })
        })
      })
    }
  },
  watch: {
    'digitalForm': {
      handler() {
        this.compileComments()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
</style>
